import { TABLET_BREAKPOINT_PX } from 'common/variables';

/* Get brief questions that should be visible. */
export const getVisibleBriefQuestions = (allQuestions) => {
  /* never show public description for PAP brief steps, since it's set in a different PAP section */
  const excluded = ['description'];
  return allQuestions.filter(q => !excluded.includes(q.name));
}

/* Get a specific PAP URL given a set of parameters */
export const getPapUrl = (opts) => {
  const { step='brief', subStep, projectId, categorySlug, subCategorySlug } = opts;
  const baseUrl = '/start-a-project';
  if (step === 'brief') {
    if (projectId) {
      return `${baseUrl}/new/${projectId}/${step}/${subStep}/`;
    }
    return `${baseUrl}/${categorySlug}/${subCategorySlug}/${step}/${subStep}/`;
  } else if (step === 'details') {
    return `${baseUrl}/${projectId}/${step}/${subStep}/`;
  } else {
    return `${baseUrl}/${projectId}/${step}/`;
  }
}

export const showAllQuestionsAtOnce = () => {
  return window.innerWidth > TABLET_BREAKPOINT_PX;
}



// WEBPACK FOOTER //
// ./pap_v2/utils.js